<info-tooltip (click)="openInfoPanel()" [tooltip]="tooltip"></info-tooltip>
